<template>
    <Modal2
        :title="`Zoho ${module} Picker`"
        ok-text="Seçimi Tamamla"
        cancel-text="İptal"
        @ok="handleConfirm"
        @cancel="$emit('cancel')"
        className="zoho-record-picker-modal"
    >
        <div class="zoho-record-picker">
            <a-table
                :columns="columns"
                :data-source="records"
                :row-selection="{ selectedRowKeys: selectedKeys, onChange: onSelectionChange }"
                :loading="loading"
            >
            </a-table>
        </div>
    </Modal2>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { ZOHO_API } from "../../../../api/zoho";
import Modal2 from "../../../common/Modal2.vue";

export default Vue.extend({
    name: "ZohoRecordPicker",
    components: { Modal2 },
    props: {
        phone: {
            type: String,
            required: true,
        },
        module: {
            type: String,
            required: true,
        },
        contactId: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            records: [],
            loading: false,
            selectedKeys: [],
            selectedRecords: [],
        };
    },
    computed: {
        columns() {
            const commonColumns = [
                { title: "ID", dataIndex: "id", key: "id" },
                {
                    title: "Oluşturulma Tarihi",
                    dataIndex: "Created_Time",
                    key: "Created_Time",
                    customRender: (text) => moment(text).format("DD.MM.YYYY HH:mm"),
                },
            ];

            switch (this.module) {
                case "Contacts":
                    return [
                        ...commonColumns,
                        { title: "İsim", dataIndex: "Full_Name", key: "Full_Name" },
                        { title: "Email", dataIndex: "Email", key: "Email" },
                        { title: "Telefon", dataIndex: "Phone", key: "Phone" },
                    ];
                case "Leads":
                    return [
                        ...commonColumns,
                        { title: "İsim", dataIndex: "First_Name", key: "First_Name" },
                        { title: "Şirket", dataIndex: "Company", key: "Company" },
                        { title: "Email", dataIndex: "Email", key: "Email" },
                    ];
                case "Deals":
                    return [
                        ...commonColumns,
                        { title: "Başlık", dataIndex: "Deal_Name", key: "Deal_Name" },
                        { title: "Tutar", dataIndex: "Amount", key: "Amount" },
                        { title: "Aşama", dataIndex: "Stage", key: "Stage" },
                    ];
                case "Sales_Orders":
                    return [
                        ...commonColumns,
                        { title: "Layout", dataIndex: "Layout.name", key: "Layout.name" },
                        { title: "Contact", dataIndex: "Contact_Name.name", key: "Contact_Name.name" },
                        { title: "Deal Name", dataIndex: "Deal_Name.name", key: "Deal_Name.name" },
                        { title: "Operasyon_Durumu", dataIndex: "Operasyon_Durumu", key: "Operasyon_Durumu" },
                    ];
                default:
                    return commonColumns;
            }
        },
    },
    methods: {
        async fetchRecords() {
            this.loading = true;
            try {
                const data = this.contactId
                    ? await ZOHO_API.searchRecordsByContactId(this.module, this.contactId)
                    : await ZOHO_API.searchRecordsByPhone(this.module, this.phone);
                this.records = data.map((record) => ({ ...record, key: record.id }));
            } catch (error) {
            } finally {
                this.loading = false;
            }
        },
        onSelectionChange(selectedRowKeys, selectedRows) {
            this.selectedKeys = selectedRowKeys;
            this.selectedRecords = selectedRows;
        },
        handleConfirm() {
            this.$emit("selected", this.selectedRecords);
        },
    },
    created() {
        this.fetchRecords();
    },
});
</script>

<style scoped lang="scss">
.zoho-record-picker {
    min-height: 300px;
    min-width: 600px;
}
</style>
<style>
.zoho-record-picker-modal {
    .ant-modal {
        width: max-content !important;
        max-width: 80vw !important;
        overflow: auto !important;
    }
}
</style>
